import { Box, IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import AddIcon from '@mui/icons-material/Add'
import { MAX_UPLOAD_COUNT } from './constants'

interface PhotoPreviewRowProps {
  files: FileList | null
  maxUploadCount?: number
  height?: number
  alt?: string
  onDelete?: (index: number) => void
  onAdd?: (files: FileList) => void
}

export default function PhotoPreviewRow({
  files,
  maxUploadCount = MAX_UPLOAD_COUNT,
  alt = 'preview',
  onDelete,
  onAdd,
}: PhotoPreviewRowProps) {
  const tileSize = 156
  const width = tileSize
  const height = tileSize
  const fileArr = files ? Array.from(files) : []

  const renderPlusTile = () => {
    if (!onAdd) return null
    return (
      <Box
        sx={{
          width: width,
          height: height,
          borderRadius: (theme) => theme.spacing(0.5),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#f1f1f1',
          flexShrink: 0,
        }}
      >
        <Box
          component="label"
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <input
            aria-label="add-photo"
            type="file"
            accept="image/*"
            max={maxUploadCount}
            multiple
            hidden
            onChange={(e) => {
              if (e.target.files && onAdd) onAdd(e.target.files)
              e.currentTarget.value = ''
            }}
          />
          <AddIcon color="primary" />
        </Box>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(2, ${width}px)`,
        gap: 2,
        my: 2,
      }}
    >
      {fileArr.map((file, idx) => (
        <Box
          key={idx}
          sx={{
            position: 'relative',
            width: width,
            height: height,
            borderRadius: 2,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#fafafa',
            boxShadow: '0 1px 0 rgba(0,0,0,0.06)',
          }}
        >
          <img
            src={URL.createObjectURL(file)}
            alt={alt}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          {onDelete && (
            <IconButton
              sx={(theme) => ({
                position: 'absolute',
                padding: theme.spacing(0.125),
                backgroundColor: 'rgba(0,0,0,.25) !important',
                color: '#fff',
                top: theme.spacing(2),
                right: theme.spacing(2),
              })}
              onClick={() => onDelete(idx)}
            >
              <ClearIcon />
            </IconButton>
          )}
        </Box>
      ))}
      {fileArr.length < maxUploadCount && renderPlusTile()}
    </Box>
  )
}
